export default {
    data() {
        return {
            sign_doctor_list:[],
            operation_place_list:[],
            operation_doctor_list:[],
            assistant1_list:[],
            assistant2_list:[],
            operation_fee_list:[],
            operation_name_list:[],
            operation_date_list:[],
            operation_note_list:[],
            record_person_list:[],
            operation_position_list:[]
        }
    },
    created () {
        this.fillLocal();
        
    },
    methods: {
        updateLocal(type){
            if (type === 0) {
                this.sign_doctor_list = []
                this.getLocalList(this.sign_doctor_list, "sign_doctor_list");
            }else if (type === 1){
                this.operation_place_list = []
                this.getLocalList(this.operation_place_list, "operation_place_list");
            }else if (type === 2){
                this.operation_doctor_list = []
                this.getLocalList(this.operation_doctor_list, "operation_doctor_list");
            }else if (type === 3){
                this.assistant1_list = []
                this.getLocalList(this.assistant1_list, "assistant1_list");
            }else if (type === 4){
                this.assistant2_list = []
                this.getLocalList(this.assistant2_list, "assistant2_list");
            }else if (type === 5){
                this.operation_fee_list = []
                this.getLocalList(this.operation_fee_list, "operation_fee_list");
            }else if (type === 6){
                this.operation_name_list = []
                this.getLocalList(this.operation_name_list, "operation_name_list");
            }else if (type === 7){
                this.operation_date_list = []
                this.getLocalList(this.operation_date_list, "operation_date_list");
            }else if (type === 8){
                this.operation_note_list = []
                this.getLocalList(this.operation_note_list, "operation_note_list");
            } else if (type === 9){
                this.record_person_list = []
                this.getLocalList(this.record_person_list, "record_person_list");
            }  else if (type === 10){
                this.operation_position_list = []
                this.getLocalList(this.operation_position_list, "operation_position_list");
            }  
            
        },
        // 组件在mount时，自动填入上次的信息
        fillLocal(){
            this.cosmetRegistration.operation_name = this.getLastLocalListVal("operation_name_list");
            this.cosmetRegistration.sign_doctor = this.getLastLocalListVal("sign_doctor_list");
            this.cosmetRegistration.operation_place = this.getLastLocalListVal("operation_place_list");
            this.cosmetRegistration.operation_doctor = this.getLastLocalListVal("operation_doctor_list");
            // this.cosmetRegistration.assistant1 = this.getLastLocalListVal("assistant1_list");
            // this.cosmetRegistration.assistant2 = this.getLastLocalListVal("assistant2_list");
            this.cosmetRegistration.operation_fee = this.getLastLocalListVal("operation_fee_list");
            //this.cosmetRegistration.operation_date = this.getLastLocalListVal("operation_date_list");
            },
        signdoctorlist(mainSuggesionString, cb) {
            let results = this.sign_doctor_list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        operationplacelist(mainSuggesionString, cb) {
            let results = this.operation_place_list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        operationdoctorlist(mainSuggesionString, cb) {
            let results = this.operation_doctor_list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        assistant1list(mainSuggesionString, cb) {
            let results = this.assistant1_list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        assistant2list(mainSuggesionString, cb) {
            let results = this.assistant2_list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        operationfeelist(mainSuggesionString, cb) {
            let results = this.operation_fee_list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        operationnamelist(mainSuggesionString, cb) {
            let results = this.operation_name_list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        operationnotelist(mainSuggesionString, cb) {
            let results = this.operation_note_list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        recordpersonlist(mainSuggesionString, cb) {
            let results = this.record_person_list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        operationpositionlist(mainSuggesionString, cb){
            let results = this.operation_position_list;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        getLastLocalListVal(localName) {
            // thisData =[]
            let tmpList = localStorage.getItem(localName);
            if (tmpList) {
                let data = JSON.parse(tmpList);
                return data[0]
            }else{
                return ''
            }
        },
        getLocalList(thisData, localName) {
            // thisData =[]
            let tmpList = localStorage.getItem(localName);
            if (tmpList) {
                let data = JSON.parse(tmpList);
                for (const item of data) {
                thisData.push({ value: item });
                }
            }
        },
        saveSuggesion(type) {
            if (type === 0) {
                this.saveLocalList(
                this.cosmetRegistration.sign_doctor,
                "sign_doctor_list"
                );
            } else if (type === 1) {
                this.saveLocalList(
                this.cosmetRegistration.operation_place,
                "operation_place_list"
                );
            }else if (type === 2) {
                this.saveLocalList(
                    this.cosmetRegistration.operation_doctor,
                    "operation_doctor_list"
                );
            }else if (type === 3) {
                this.saveLocalList(
                    this.cosmetRegistration.assistant1,
                    "assistant1_list"
                );
            }else if (type === 4) {
                this.saveLocalList(
                    this.cosmetRegistration.assistant2,
                    "assistant2_list"
                );
            }else if (type === 5) {
                this.saveLocalList(
                    this.cosmetRegistration.operation_fee,
                    "operation_fee_list"
                );
            }else if (type === 6) {
                this.saveLocalList(
                    this.cosmetRegistration.operation_name,
                    "operation_name_list"
                );
            }else if (type === 7) {
                this.saveLocalList(
                    this.cosmetRegistration.operation_date,
                    "operation_date_list"
                );
            }else if (type === 8) {
                this.saveLocalList(
                    this.cosmetRegistration.note,
                    "operation_note_list"
                );
            }else if (type === 9) {
                this.saveLocalList(
                    this.cosmetRegistration.record_person,
                    "record_person_list"
                );
            }else if (type === 10) {
                this.saveLocalList(
                    this.cosmetRegistration.operation_position_new,
                    "operation_position_list"
                );
            }
        },
        saveLocalList(thisData, localName) {
            if (thisData) {
                let tmpList = localStorage.getItem(localName);
                if (tmpList) {
                let data = JSON.parse(tmpList);
                data.unshift(thisData);
                let NewData = _.chunk(_.uniq(data), 5)[0];
                localStorage.setItem(localName, JSON.stringify(NewData));
                } else {
                let data = [];
                data.unshift(thisData);
                localStorage.setItem(localName, JSON.stringify(data));
                }
            }
        },
    },
}